import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

const MainDiv = styled.div`
  padding: var(--space-12);
  .active {
    background-color: var(--background-hover-navbar);
    border-radius: var(--border-radius-8);
    width: fit-content;
    .desktop-profile:hover {
      background-color: var(--background-hover-navbar);
    }
  }
  .desktop-active {
    background-color: var(--background-hover);
    border-radius: var(--border-radius-8);
    width: fit-content;
  }
`;

const Buttons = styled.div`
  background: var(--background-tertiary);
  border-radius: var(--border-radius-12);
  display: flex;
  padding: var(--space-4);
  margin-inline: var(--space-4);
`;

const Profile = styled.div`
  gap: var(--space-11);
  ${AlignCenter}
  cursor: pointer;
  width: max-content;
  padding: var(--space-5) var(--space-8) var(--space-5) var(--space-5);

  &:hover {
    background-color: var(--background-hover-navbar);
    border-radius: var(--border-radius-8);
  }
  .profile-image {
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-4);
    object-position: center;
    object-fit: cover;
    aspect-ratio: 1/1;
  }
  .dropdown-icon {
    transform: rotate(180deg);
  }
  .stroke-color {
    stroke: var(--text-primary);
  }
`;

const UserName = styled.div`
  ${Typography.body_md_semibold};
  color: var(--text-primary);
  p {
    margin: var(--space-0);
    ${Typography.body_sm};
    color: var(--text-primary);
  }
`;

const WorkspaceIcon = styled.div`
  width: 20px;
  height: 20px;
  ${FlexCenter}
  border-radius: var(--border-radius-4);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-tertiary);
  .workspace-icon {
    path {
      fill: var(--text-secondary);
    }
    rect {
      fill: var(--background-tertiary);
    }
  }
`;

export { Buttons, MainDiv, Profile, UserName, WorkspaceIcon };
